import { useMutation, UseMutationOptions, useQuery, UseQueryOptions } from "@tanstack/react-query";
import $api from "../../../api/$api";
import { IupdateCohortPeriod, TDataToken, TQueries } from "./type";
export const getGroupPeriod = (
    data: TDataToken,
    payload: TQueries
) => {
    return $api
        .get("/admin/group-periods/details", { token: data.accessToken, params: { ...payload } })
        .then((response) => {
            return response;
        });
};
export const useGetGroupPeriod = (data: TDataToken, queries: TQueries, config?: {}) => {
    return useQuery({
        queryKey: ["group-period", queries],
        queryFn: () => getGroupPeriod(data, queries),
        ...config as UseQueryOptions<any>
    });
};

// update cohort period
export const updateCohortPeriod = (
    data: TDataToken,
    payload: IupdateCohortPeriod
  ) => {
    return $api
      .put("/admin/group-periods/update", { ...payload }, { token: data.accessToken })
      .then((response) => {
        return response;
      });
  };
  
  export const useUpdateCohortPeriod = (
    data: TDataToken,
    config?: UseMutationOptions<any, unknown, IupdateCohortPeriod>
  ) => {
    return useMutation({
      mutationFn: (payload: IupdateCohortPeriod) =>
        updateCohortPeriod(data, payload),
      ...config
    });
  };

